// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body, div, span, applet, object, iframe,
h1, h2, h3, h4, h5, h6, p, blockquote, pre,
a, abbr, acronym, address, big, cite, code,
del, dfn, em, img, ins, kbd, q, s, samp,
small, strike, strong, sub, sup, tt, var,
b, u, i, center,
dl, dt, dd, ol, ul, li,
fieldset, form, label, legend,
table, caption, tbody, tfoot, thead, tr, th, td,
article, aside, canvas, details, embed,
figure, figcaption, footer, header, hgroup,
menu, nav, output, ruby, section, summary,
time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
}
/* HTML5 display-role reset for older browsers */
article, aside, details, figcaption, figure,
footer, header, hgroup, menu, nav, section {
    display: block;
}
html, body {
    overflow: hidden;
    height: 100%;
}
body {
    line-height: 1;
}
ol, ul {
    list-style: none;
}
blockquote, q {
    quotes: none;
}
blockquote:before, blockquote:after,
q:before, q:after {
    content: '';
    content: none;
}
table {
    border-collapse: collapse;
    border-spacing: 0;
}

/* customize */
*,
:after,
:before {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
    /* user-select: none; */
    outline: none !important;
    /* font-family: -apple-system,BlinkMacSystemFont,Helvetica Neue,PingFang SC,Microsoft YaHei,Source Han Sans SC,Noto Sans CJK SC,WenQuanYi Micro Hei,sans-serif !important; */
    font-family: 'PingFangSCMedium', sans-serif;
}

a {
    cursor: pointer;
    text-decoration: none;
}

body {
    /* width: 100% !important; */
    overflow: hidden;
    font-family: 'PingFangSCMedium', sans-serif;
}

/* 禁止拖动图片 */
img {
    /* pointer-events: none; */
    -webkit-user-drag: none;
}

body {
    margin: 0;
    overflow: hidden;
    transition: transform 0.3s ease-out, width 0.3s ease-out, height 0.3s ease-out;
    transform-origin: top left;
    width: 100vw;
    height: 100vh;
}

#root {
    width: 100%;
    height: 100%;
}

.cite_container {
    position: relative;
    display: inline-block;
}

.cite_icon_box {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 25px;
    padding: 0 5px;
    background-color: #fff;
    border: 1px solid #E7E7E7;
    border-radius: 25px;
    color: white;
    cursor: pointer;
    box-sizing: content-box;
}

.cite_icon {
    width: 15px;
    height: 15px;
    font-size: 12px;
}

.cite_tooltip {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    z-index: 1;
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.3s;
}

.cite_container:hover .cite_tooltip {
    visibility: visible;
    opacity: 1;
}

.cite_tooltip_content {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: auto;
    height: 25px;
    padding: 0 20px 1px 5px;
    border: 1px solid #E7E7E7;
    border-radius: 25px;
    background-color: #fff;
    box-sizing: content-box;
    cursor: pointer;
}

.cite_text {
    font-size: 12px;
    padding: 0 5px 1px;
    white-space: nowrap;
    color: #323A45;
}

.material_mode_query_img {
    max-height: 216px;
    border-radius: 6px;
}

.material_mode_info_container {
    width: 100%;
    height: 100%;
    padding: 4px 0 4px 4px;
    /* width: 790px; */
}

.material_mode_item {
    display: flex;
    padding: 15px;
    border: 1px solid #f9f9f9;
    border-radius: 12px;
    margin-top: 16px;
}

.material_mode_item:hover {
    background-color: #eeeeee;
    cursor: pointer;
    border: 1px solid #E1E1E1;
}

.material_mode_item:active {
    background-color: #ffffff;
    transition: all 0.3s ease;
}

.material_mode_number_box {
    flex-shrink: 0; /* 禁止缩小 */
    width: 30px;
    height: 60px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    margin-right: 20px;
}

.material_mode_item_no {
    font-size: 12px;
    line-height: 27px;
}

.material_mode_item_number {
    font-size: 24px;
    font-weight: bold;
    line-height: 27px;
    color: #17a8b5;
}

.material_mode_item_image_box {
    flex-shrink: 0; /* 禁止缩小 */
    width: 125px;
    height: 60px;
    margin-right: 20px;
    /* overflow: hidden; 隐藏超出容器的部分 */
}

.material_mode_item_image {
    max-width: 100%;
    height: 60px;
    transition: transform 0.3s ease, box-shadow 0.3s ease; /* 添加过渡效果 */
    cursor: pointer;
    border-radius: 6px;
}

.material_mode_item_image:hover {
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.25);
    transform: scale(1.1); /* 悬浮时放大 1.1 倍 */
}

.material_mode_item_text_box {
    flex-grow: 1;    /* 占据剩余空间 */
    flex-shrink: 1;  /* 允许缩小 */
    flex-basis: 0%;  /* 初始基准尺寸设为0 */
    margin-right: 6px;
    /* 或者简写为 */
    /* flex: 1; */
}

.material_mode_item_info {
    width: auto;
}

.material_mode_item_title,
.material_mode_item_text {
    font-size: 16px;
    line-height: 27px;
    color: #323a45;
}

.material_mode_item_title {
    font-weight: bold;
}

.material_mode_info_tabs_container {
    position: relative;
}

/* 隐藏单选按钮 */
[id^="material_mode_info_tab_id"]:nth-child(odd),
[id^="material_mode_info_tab_id"]:nth-child(even) {
    display: none;
}

/* Tab标签容器 */
.material_mode_info_tab {
    display: flex;
    justify-content: flex-end;
    width: calc(100% - 5px);
    padding-bottom: 16px;
    border-bottom: 1px solid #D9D9D9;
}

/* Tab标签样式 */
.material_mode_info_tab_label1,
.material_mode_info_tab_label1:hover,
.material_mode_info_tab_label2,
.material_mode_info_tab_label2:hover {
    padding: 4px 16px;
    font-weight: bold;
    line-height: 27px;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.3s;
}

.material_mode_info_tab_label1 {
    margin: 0 6px;
}

.material_mode_info_tab_label2 {
    margin-left: 6px;
}

.material_mode_info_tab_label1:hover,
.material_mode_info_tab_label2:hover {
    background-color: #f0f0f0;
}

/* 选中状态样式 */
[id^="material_mode_info_tab_id"]:nth-child(odd):checked ~ .material_mode_info_tab .material_mode_info_tab_label1,
[id^="material_mode_info_tab_id"]:nth-child(even):checked ~ .material_mode_info_tab .material_mode_info_tab_label2 {
    background: #17a8b5;
    color: #fff;
}

.material_mode_info_tab_div_line {
    width: 2px;
    height: 35px;
    background-color: #d9d9d9;
}


/* 内容项通用样式 */
.material_mode_info_tab_content {
    display: none;
    width: 100%;
    max-height: 810px;
    overflow-x: hidden;
    overflow-y: scroll;
}

/* 自定义滚动条 */
.material_mode_info_tab_content::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 5px;
    height: 5px;
}

/*滚动条里面小方块*/
.material_mode_info_tab_content::-webkit-scrollbar-thumb {
    cursor: pointer;
    border-radius: 5px;
    background: #e9e9e9;
    -webkit-transition: color .2s ease;
    transition: color .2s ease;
}

.material_mode_info_tab_content::-webkit-scrollbar-thumb:hover {
    background: #e3e3e3;
}

/* 显示选中的内容 */
[id^="material_mode_info_tab_id"]:nth-child(odd):checked ~ .material_mode_info_tab_contents .material_mode_info_tab_content1,
[id^="material_mode_info_tab_id"]:nth-child(even):checked ~ .material_mode_info_tab_contents .material_mode_info_tab_content2 {
    display: block;
}
`, "",{"version":3,"sources":["webpack://./src/styles/index.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;IAaI,SAAS;IACT,UAAU;IACV,SAAS;IACT,eAAe;IACf,aAAa;IACb,wBAAwB;AAC5B;AACA,gDAAgD;AAChD;;IAEI,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,cAAc;AAClB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,YAAY;AAChB;AACA;;IAEI,WAAW;IACX,aAAa;AACjB;AACA;IACI,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA,cAAc;AACd;;;IAGI,UAAU;IACV,SAAS;IACT,sBAAsB;IACtB,uBAAuB;IACvB,wBAAwB;IACxB,4KAA4K;IAC5K,2CAA2C;AAC/C;;AAEA;IACI,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,4BAA4B;IAC5B,gBAAgB;IAChB,2CAA2C;AAC/C;;AAEA,WAAW;AACX;IACI,0BAA0B;IAC1B,uBAAuB;AAC3B;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,8EAA8E;IAC9E,0BAA0B;IAC1B,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,2BAA2B;IAC3B,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,yBAAyB;IACzB,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,cAAc,EAAE,SAAS;IACzB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,cAAc,EAAE,SAAS;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,qDAAqD,EAAE,WAAW;IAClE,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,4CAA4C;IAC5C,qBAAqB,EAAE,gBAAgB;AAC3C;;AAEA;IACI,YAAY,KAAK,WAAW;IAC5B,cAAc,GAAG,SAAS;IAC1B,cAAc,GAAG,cAAc;IAC/B,iBAAiB;IACjB,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA,WAAW;AACX;;IAEI,aAAa;AACjB;;AAEA,YAAY;AACZ;IACI,aAAa;IACb,yBAAyB;IACzB,uBAAuB;IACvB,oBAAoB;IACpB,gCAAgC;AACpC;;AAEA,YAAY;AACZ;;;;IAII,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA,WAAW;AACX;;IAEI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,yBAAyB;AAC7B;;;AAGA,YAAY;AACZ;IACI,aAAa;IACb,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA,WAAW;AACX;IACI,wBAAwB;IACxB,UAAU;IACV,WAAW;AACf;;AAEA,WAAW;AACX;IACI,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IAEnB,kCAA0B;IAA1B,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;AACvB;;AAEA,YAAY;AACZ;;IAEI,cAAc;AAClB","sourcesContent":["html, body, div, span, applet, object, iframe,\nh1, h2, h3, h4, h5, h6, p, blockquote, pre,\na, abbr, acronym, address, big, cite, code,\ndel, dfn, em, img, ins, kbd, q, s, samp,\nsmall, strike, strong, sub, sup, tt, var,\nb, u, i, center,\ndl, dt, dd, ol, ul, li,\nfieldset, form, label, legend,\ntable, caption, tbody, tfoot, thead, tr, th, td,\narticle, aside, canvas, details, embed,\nfigure, figcaption, footer, header, hgroup,\nmenu, nav, output, ruby, section, summary,\ntime, mark, audio, video {\n    margin: 0;\n    padding: 0;\n    border: 0;\n    font-size: 100%;\n    font: inherit;\n    vertical-align: baseline;\n}\n/* HTML5 display-role reset for older browsers */\narticle, aside, details, figcaption, figure,\nfooter, header, hgroup, menu, nav, section {\n    display: block;\n}\nhtml, body {\n    overflow: hidden;\n    height: 100%;\n}\nbody {\n    line-height: 1;\n}\nol, ul {\n    list-style: none;\n}\nblockquote, q {\n    quotes: none;\n}\nblockquote:before, blockquote:after,\nq:before, q:after {\n    content: '';\n    content: none;\n}\ntable {\n    border-collapse: collapse;\n    border-spacing: 0;\n}\n\n/* customize */\n*,\n:after,\n:before {\n    padding: 0;\n    margin: 0;\n    box-sizing: border-box;\n    /* user-select: none; */\n    outline: none !important;\n    /* font-family: -apple-system,BlinkMacSystemFont,Helvetica Neue,PingFang SC,Microsoft YaHei,Source Han Sans SC,Noto Sans CJK SC,WenQuanYi Micro Hei,sans-serif !important; */\n    font-family: 'PingFangSCMedium', sans-serif;\n}\n\na {\n    cursor: pointer;\n    text-decoration: none;\n}\n\nbody {\n    /* width: 100% !important; */\n    overflow: hidden;\n    font-family: 'PingFangSCMedium', sans-serif;\n}\n\n/* 禁止拖动图片 */\nimg {\n    /* pointer-events: none; */\n    -webkit-user-drag: none;\n}\n\nbody {\n    margin: 0;\n    overflow: hidden;\n    transition: transform 0.3s ease-out, width 0.3s ease-out, height 0.3s ease-out;\n    transform-origin: top left;\n    width: 100vw;\n    height: 100vh;\n}\n\n#root {\n    width: 100%;\n    height: 100%;\n}\n\n.cite_container {\n    position: relative;\n    display: inline-block;\n}\n\n.cite_icon_box {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    height: 25px;\n    padding: 0 5px;\n    background-color: #fff;\n    border: 1px solid #E7E7E7;\n    border-radius: 25px;\n    color: white;\n    cursor: pointer;\n    box-sizing: content-box;\n}\n\n.cite_icon {\n    width: 15px;\n    height: 15px;\n    font-size: 12px;\n}\n\n.cite_tooltip {\n    position: absolute;\n    top: 50%;\n    left: 0;\n    transform: translateY(-50%);\n    z-index: 1;\n    visibility: hidden;\n    opacity: 0;\n    transition: opacity 0.3s;\n}\n\n.cite_container:hover .cite_tooltip {\n    visibility: visible;\n    opacity: 1;\n}\n\n.cite_tooltip_content {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    width: auto;\n    height: 25px;\n    padding: 0 20px 1px 5px;\n    border: 1px solid #E7E7E7;\n    border-radius: 25px;\n    background-color: #fff;\n    box-sizing: content-box;\n    cursor: pointer;\n}\n\n.cite_text {\n    font-size: 12px;\n    padding: 0 5px 1px;\n    white-space: nowrap;\n    color: #323A45;\n}\n\n.material_mode_query_img {\n    max-height: 216px;\n    border-radius: 6px;\n}\n\n.material_mode_info_container {\n    width: 100%;\n    height: 100%;\n    padding: 4px 0 4px 4px;\n    /* width: 790px; */\n}\n\n.material_mode_item {\n    display: flex;\n    padding: 15px;\n    border: 1px solid #f9f9f9;\n    border-radius: 12px;\n    margin-top: 16px;\n}\n\n.material_mode_item:hover {\n    background-color: #eeeeee;\n    cursor: pointer;\n    border: 1px solid #E1E1E1;\n}\n\n.material_mode_item:active {\n    background-color: #ffffff;\n    transition: all 0.3s ease;\n}\n\n.material_mode_number_box {\n    flex-shrink: 0; /* 禁止缩小 */\n    width: 30px;\n    height: 60px;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: center;\n    margin-right: 20px;\n}\n\n.material_mode_item_no {\n    font-size: 12px;\n    line-height: 27px;\n}\n\n.material_mode_item_number {\n    font-size: 24px;\n    font-weight: bold;\n    line-height: 27px;\n    color: #17a8b5;\n}\n\n.material_mode_item_image_box {\n    flex-shrink: 0; /* 禁止缩小 */\n    width: 125px;\n    height: 60px;\n    margin-right: 20px;\n    /* overflow: hidden; 隐藏超出容器的部分 */\n}\n\n.material_mode_item_image {\n    max-width: 100%;\n    height: 60px;\n    transition: transform 0.3s ease, box-shadow 0.3s ease; /* 添加过渡效果 */\n    cursor: pointer;\n    border-radius: 6px;\n}\n\n.material_mode_item_image:hover {\n    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.25);\n    transform: scale(1.1); /* 悬浮时放大 1.1 倍 */\n}\n\n.material_mode_item_text_box {\n    flex-grow: 1;    /* 占据剩余空间 */\n    flex-shrink: 1;  /* 允许缩小 */\n    flex-basis: 0%;  /* 初始基准尺寸设为0 */\n    margin-right: 6px;\n    /* 或者简写为 */\n    /* flex: 1; */\n}\n\n.material_mode_item_info {\n    width: auto;\n}\n\n.material_mode_item_title,\n.material_mode_item_text {\n    font-size: 16px;\n    line-height: 27px;\n    color: #323a45;\n}\n\n.material_mode_item_title {\n    font-weight: bold;\n}\n\n.material_mode_info_tabs_container {\n    position: relative;\n}\n\n/* 隐藏单选按钮 */\n[id^=\"material_mode_info_tab_id\"]:nth-child(odd),\n[id^=\"material_mode_info_tab_id\"]:nth-child(even) {\n    display: none;\n}\n\n/* Tab标签容器 */\n.material_mode_info_tab {\n    display: flex;\n    justify-content: flex-end;\n    width: calc(100% - 5px);\n    padding-bottom: 16px;\n    border-bottom: 1px solid #D9D9D9;\n}\n\n/* Tab标签样式 */\n.material_mode_info_tab_label1,\n.material_mode_info_tab_label1:hover,\n.material_mode_info_tab_label2,\n.material_mode_info_tab_label2:hover {\n    padding: 4px 16px;\n    font-weight: bold;\n    line-height: 27px;\n    border-radius: 6px;\n    cursor: pointer;\n    transition: all 0.3s;\n}\n\n.material_mode_info_tab_label1 {\n    margin: 0 6px;\n}\n\n.material_mode_info_tab_label2 {\n    margin-left: 6px;\n}\n\n.material_mode_info_tab_label1:hover,\n.material_mode_info_tab_label2:hover {\n    background-color: #f0f0f0;\n}\n\n/* 选中状态样式 */\n[id^=\"material_mode_info_tab_id\"]:nth-child(odd):checked ~ .material_mode_info_tab .material_mode_info_tab_label1,\n[id^=\"material_mode_info_tab_id\"]:nth-child(even):checked ~ .material_mode_info_tab .material_mode_info_tab_label2 {\n    background: #17a8b5;\n    color: #fff;\n}\n\n.material_mode_info_tab_div_line {\n    width: 2px;\n    height: 35px;\n    background-color: #d9d9d9;\n}\n\n\n/* 内容项通用样式 */\n.material_mode_info_tab_content {\n    display: none;\n    width: 100%;\n    max-height: 810px;\n    overflow-x: hidden;\n    overflow-y: scroll;\n}\n\n/* 自定义滚动条 */\n.material_mode_info_tab_content::-webkit-scrollbar {\n    -webkit-appearance: none;\n    width: 5px;\n    height: 5px;\n}\n\n/*滚动条里面小方块*/\n.material_mode_info_tab_content::-webkit-scrollbar-thumb {\n    cursor: pointer;\n    border-radius: 5px;\n    background: #e9e9e9;\n    -webkit-transition: color .2s ease;\n    transition: color .2s ease;\n}\n\n.material_mode_info_tab_content::-webkit-scrollbar-thumb:hover {\n    background: #e3e3e3;\n}\n\n/* 显示选中的内容 */\n[id^=\"material_mode_info_tab_id\"]:nth-child(odd):checked ~ .material_mode_info_tab_contents .material_mode_info_tab_content1,\n[id^=\"material_mode_info_tab_id\"]:nth-child(even):checked ~ .material_mode_info_tab_contents .material_mode_info_tab_content2 {\n    display: block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
